
<div class="row">
    <div class="col-md-6">
      <img src="assets/images/img-fun.png" class="img-fluid" />
    </div>
<div class="col-md-6 testimonial-box" #testimonials>
<div class="box colorGrey float-left p-4"  *ngFor="let item of itemList">
    <p class="desc">
      {{item.description}}
    </p>
    <div class="d-flex">
      <div class="testimonialImage">
        <img src={{item.image}} class="img-fluid" />
      </div>
      <p class="pl-3">
        <span class="name d-block">{{item.name}}</span>
        <span class="job d-block">{{item.title}}</span>
      </p>
    </div>
  </div>
</div>
</div>
